import React from "react";
import { Link } from "react-router-dom";
const FeaturedCellAndGeneTherapy = () => {
  return (
    <div className="row">
      <div className="col align-self-center">
        <Link to="/digital-assays/featured-content/cell-and-gene-therapy">
          <h4>Cell and Gene Therapy Assays​</h4>
          <p>
            Explore pre-designed assays for C&amp;GT and a design engine for
            custom Gene of Interest assays.
          </p>
        </Link>
      </div>
    </div>
  );
};

export default FeaturedCellAndGeneTherapy;
